import Loader from "@components/Loader/Loader";
import { FunctionComponent } from "react";
import LatestBlogPostsTemplate from "../C225_LatestBlogPosts/LatestBlogPostsTemplate";
import { Results } from "../CoveoSearchComponent/CoveoSearchComponent";

interface ResultListProps {
  results: Results[];
  viewMoreLink?: string;
  totalResults?: number;
  isLoading?: boolean;
}

const ResultListRenderer: FunctionComponent<ResultListProps> = ({
  results,
  viewMoreLink,
  totalResults,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <div className="p-16 flex flex-col items-center">
        <Loader
          color="#001e62"
          size={50}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <LatestBlogPostsTemplate
      totalResults={totalResults}
      viewMoreLink={viewMoreLink}
      results={results}
    />
  );
};

export default ResultListRenderer;
